import React, { useCallback } from 'react';

import styled, { css } from 'styled-components';

import { useLoyalty } from '~/techstyle-shared/react-accounts';
import {
  Button,
  Tooltip,
  useBreakpoint,
  useProductDetailContext,
} from '~/techstyle-shared/react-components';
import { FormattedMessage } from '~/techstyle-shared/react-intl';

import useLoyaltyPricing from '../../utils/useLoyaltyPricing';

import { useProductDetailCTAContext } from './ProductDetailCTAContext';

const Wrapper = styled.div`
  margin-top: 32px;
`;

const LoyaltyAddToBagButton = styled(Button).attrs({
  variant: 'primaryAddToBag',
  size: 'lg',
})`
  width: 100%;
`;

const labelStyle = css`
  font-size: 18px;
  font-weight: 800;
  letter-spacing: ${-0.4 / 18}em;
  color: ${({ theme }) => theme.colors.textLight};
`;

const LoyaltyTooltipContent = styled(Tooltip.Content)`
  font-size: 12px;
  z-index: 1;
  padding: 15px;
  width: 260px;
  && {
    background-color: ${({ theme }) => theme.colors.loyaltyTooltipBg};
  }
`;

function LoyaltyAddToBag() {
  const {
    addToCart,
    handleSharedValidation,
    hasError,
    isLoading,
    onSuccessfulAddToCart,
  } = useProductDetailCTAContext();

  const { isDesktop } = useBreakpoint();
  const btnDisabled = isLoading || (hasError && isDesktop);

  const handleLoyaltyCTAClick = useCallback(async () => {
    try {
      await handleSharedValidation();
      await addToCart({ isRewardItem: true });

      onSuccessfulAddToCart && onSuccessfulAddToCart();
    } catch (error) {
      // TODO: custom error handling here
    }
  }, [addToCart, handleSharedValidation, onSuccessfulAddToCart]);

  const productDetailFromCtx = useProductDetailContext();
  const product = productDetailFromCtx.product;

  const { redemption } = useLoyalty();
  const availableLoyaltyPoints = redemption?.balance;

  const { productLoyaltyValue } = useLoyaltyPricing(product);
  const showToolTip = availableLoyaltyPoints < productLoyaltyValue;
  const disableButton =
    availableLoyaltyPoints < productLoyaltyValue || btnDisabled;

  return (
    <Wrapper>
      <Tooltip isShowing={showToolTip ? undefined : false}>
        <Tooltip.Anchor>
          <LoyaltyAddToBagButton
            labelStyle={labelStyle}
            onClick={handleLoyaltyCTAClick}
            data-autotag="pdp-atc-cta-loyalty"
            data-cnstrc-btn="add-to-cart"
            disabled={disableButton}
          >
            <FormattedMessage
              id="site_pdp.add_to_cart_loyalty"
              defaultMessage="Redeem with points"
            />
          </LoyaltyAddToBagButton>
        </Tooltip.Anchor>
        <LoyaltyTooltipContent>
          <FormattedMessage
            id="site_pdp.notice_no_loyaltypts_message"
            defaultMessage="You don't have enough enough reward points."
          />
        </LoyaltyTooltipContent>
      </Tooltip>
    </Wrapper>
  );
}

export default LoyaltyAddToBag;
